import { useState, useEffect, useCallback } from 'react';
import { API_URL } from '../config/apiConfig';
import { loadAlternateArtDisplayContextFromProgress } from '../utils/alternateArtDisplay';

/**
 * Fetches pending achievement unlocks on mount and returns the current toast to show.
 * Call this on main screens (Profile, Bank, Command Center, Welcome, BlackOps, War Effort)
 * so "Achievement unlocked" appears when the user lands after e.g. losing a game.
 * Returns { current, dismissCurrent } – render current and call dismissCurrent when the toast closes.
 */
export function usePendingAchievementToasts() {
  const [queue, setQueue] = useState([]);

  const fetchPending = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const res = await fetch(`${API_URL}/profile/pending-achievement-unlocks`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      if (Array.isArray(data.pending) && data.pending.length > 0) {
        setQueue(data.pending);
      }
      try {
        await loadAlternateArtDisplayContextFromProgress(API_URL, token);
      } catch (artErr) {
        console.error('Failed to refresh alternate art unlock context:', artErr);
      }
    } catch (err) {
      console.error('Failed to fetch pending achievement unlocks:', err);
    }
  }, []);

  useEffect(() => {
    fetchPending();
  }, [fetchPending]);

  const current = queue.length > 0 ? queue[0] : null;
  const dismissCurrent = useCallback(() => {
    setQueue((q) => q.slice(1));
  }, []);

  return { current, dismissCurrent };
}
